import { Box, Chip, Grid, Typography } from '@mui/material';
import { Skeletons } from '@prismamedia/one-components';
import { format as formatDate } from 'date-fns';
import fr from 'date-fns/locale/fr';
import { useContext, useMemo } from 'react';
import { useGlobalBrandKey } from '../../../../../../../utils/globalState';
import { CategoriesContext } from '../../../../../categories.context';
import { CREATED_AT, UPDATED_AT } from '../../../../../constants';
import { FormContext } from '../../../../../form.context';
import { isPageEditView } from '../../../../../utils';
import { useStyles } from './styles';

export const Title = () => {
  const [brandKey] = useGlobalBrandKey();
  const { isCategoriesLoading } = useContext(CategoriesContext);
  const { form } = useContext(FormContext);
  const loading = isCategoriesLoading && isPageEditView();

  const classes = useStyles({
    isLoading: loading,
  });

  const subTitle = useMemo(() => {
    const createdDate = form?.createdAt
      ? `${CREATED_AT} ${formatDate(
          new Date(form.createdAt),
          'dd/MM/yyyy à HH:mm',
          { locale: fr },
        )}`
      : null;

    const updatedAt = form?.updatedAt
      ? `${UPDATED_AT} ${formatDate(
          new Date(form.updatedAt),
          'dd/MM/yyyy à HH:mm',
          { locale: fr },
        )}`
      : null;

    if (!updatedAt && !createdDate) {
      return null;
    }

    return `${updatedAt} ${createdDate ? `- ${createdDate}` : ''}.`;
  }, [form]);

  return (
    <span className={classes.wrapper}>
      <Grid container spacing={0.5} alignItems="center">
        <Grid item style={{ maxWidth: '70%' }}>
          {loading ? (
            <Skeletons width={200} height={14} />
          ) : (
            <Box className={classes.title} component="span">
              {form.title}
            </Box>
          )}
        </Grid>
        <Grid item xs={3}>
          <Chip
            className={classes.brandKeyChip}
            label={brandKey}
            variant="filled"
            size="small"
          />
        </Grid>

        <Grid container item>
          {loading ? (
            <Skeletons width={350} height={12} />
          ) : (
            subTitle && (
              <Typography className={classes.subTitle} variant="caption">
                {subTitle}
              </Typography>
            )
          )}
        </Grid>
      </Grid>
    </span>
  );
};
